/**
 * /tenants/$slug/agents — thin route shim. Domain logic lives in
 * features/agents/.
 */

import { createFileRoute } from "@tanstack/react-router";
import {
  agentsListSearchSchema,
  type AgentsListSearch,
} from "@/features/agents/schemas";
import { fetchAgentsList } from "@/features/agents/queries";
import { queryKeys } from "@/lib/query-keys";
import { AgentsListPage } from "@/features/agents/pages/agents-list-page";

export const Route = createFileRoute("/_authed/tenants/$slug/agents/")({
  validateSearch: (raw: Record<string, unknown>): AgentsListSearch =>
    agentsListSearchSchema.parse(raw),
  loaderDeps: ({ search }) => ({ search }),
  loader: ({ context, deps }) =>
    context.queryClient.ensureQueryData({
      queryKey: queryKeys.agents.list(context.tenant.id, deps.search),
      queryFn: () => fetchAgentsList(context.tenant.id, deps.search),
    }),
  component: AgentsListPage,
});
